import axios from "axios";
import { message } from "antd";

const useHttp = () => {
  const HttpService = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      Accept: "application/json",
      "app-type": "7",
    },
  });

  HttpService.interceptors.response.use(
    (response) => response,
    async ({ error, response }) => {
      console.log("HttpService error", error);
      console.log("HttpService response", JSON.stringify(response, null, 2));
      if (response.status === 422) {
        message.error(response.data.message);
      } else if (response.status === 404) {
        message.error("درخواست مورد نظر یافت نشد");
      } else {
        message.error("خطا در برقراری ارتباط");
      }
    }
  );

  const exports = { HttpService };
  return exports;
};
export default useHttp;
